import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function AdminPortal() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">Administration Portal</h1>
            <p className="text-muted-foreground mt-2">
              Global access: users, roles, companies, operations.
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button asChild variant="default" size="sm">
              <a href="/admin/users">Users</a>
            </Button>
            <Button asChild variant="default" size="sm">
              <a href="/admin/deals">Deals</a>
            </Button>
            <Button asChild variant="default" size="sm">
              <a href="/admin/documents">Documents</a>
            </Button>
          </div>
        </header>

        <Card className="border-border bg-card">
          <CardHeader>
            <CardTitle>Overview</CardTitle>
            <CardDescription>Add your KPI tiles, recent activity, and quick actions here</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Configure LOI, NDA, Submissions metrics and activity widgets as needed.
            </p>
          </CardContent>
        </Card>
    </div>
  );
}